import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7302e4d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-ee-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Update External Examiner Details")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "body-main"
}
const _hoisted_4 = {
  key: 1,
  class: "body-main"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Firm name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Address", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_13 = { style: {"display":"flex","justify-content":"space-between","align-items":"start"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fieldname" }, "Telephone number", -1))
const _hoisted_15 = { style: {"display":"flex","justify-content":"space-between","width":"100%","align-items":"center"} }
const _hoisted_16 = { class: "text-field2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_18 = { class: "mt-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Publish on Web", -1))
const _hoisted_20 = { class: "checkbox-button" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ])
], -1))
const _hoisted_22 = {
  key: 2,
  class: "controls"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_PostcodeSearch = _resolveComponent("PostcodeSearch")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[8] || (_cache[8] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_LoadingIndicator, {
                class: "loading-indicator",
                showLoadingText: false
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", _ctx.externalExaminer.firmName === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Firm name",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.externalExaminer.firmName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.externalExaminer.firmName]
                ]),
                _hoisted_7
              ], 2),
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", _ctx.externalExaminer.address === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Address",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.externalExaminer.address) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.externalExaminer.address]
                ]),
                _hoisted_10
              ], 2),
              _hoisted_11,
              _createVNode(_component_PostcodeSearch, {
                suburbStatePostcode: _ctx.suburbStatePostcode,
                "onUpdate:suburbStatePostcode": _cache[2] || (_cache[2] = $event => ((_ctx.suburbStatePostcode) = $event)),
                suburbError: _ctx.suburbError,
                "onUpdate:suburbError": _cache[3] || (_cache[3] = $event => ((_ctx.suburbError) = $event)),
                onUpdateSuburb: _ctx.updateSuburb
              }, null, 8, ["suburbStatePostcode", "suburbError", "onUpdateSuburb"]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_ctx.externalExaminer.phoneDetail)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["input-box col-6", ((!_ctx.externalExaminer.phoneDetail?.phoneNumber || _ctx.externalExaminer.phoneDetail?.phoneNumber === '') &&  _ctx.submitPressed) ? 'error': ''])
                    }, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.externalExaminer.phoneDetail?.countryCode), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "15",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.externalExaminer.phoneDetail.phoneNumber) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, _ctx.externalExaminer.phoneDetail.phoneNumber]
                        ])
                      ]),
                      _hoisted_17
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("label", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.externalExaminer.publishOnWeb) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.externalExaminer.publishOnWeb]
                  ]),
                  _hoisted_21
                ])
              ])
            ])),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_ctx.isSaving)
                ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                    key: 0,
                    class: "loading-indicator",
                    showLoadingText: false
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-default ml-1",
                disabled: _ctx.isSaving,
                onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
              }, "Cancel", 8, _hoisted_23),
              _createElementVNode("button", {
                class: "btn btn-primary ml-2",
                disabled: _ctx.isSaving,
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.saveEE()))
              }, "Save", 8, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => []),
      _: 1
    })
  ]))
}